import {createAction} from '@reduxjs/toolkit';

export const fetchPeopleGroups = createAction('people/fetchPeopleGroups');

export type Actions = ReturnType<typeof fetchPeopleGroups>;
